import { LearningOpportunity } from "@/server/backend-api";
import { UserAdmissionFile } from "@/server/backend-api/learningOpportunityUserAdmission";
import { AdmissionProgress } from "../AdmissionProgress";
import { Markdown } from "../Markdown";
import { Section, SectionContainer, SectionProps } from "./Sections";

type Props = SectionProps & {
  learningOpp: LearningOpportunity;
  userAdmissionFiles: UserAdmissionFile[];
  containerClassName?: string;
};

export const AdmissionProgressSection = ({
  learningOpp,
  userAdmissionFiles,
  containerClassName,
  ...sectionProps
}: Props) => {
  return (
    <Section {...sectionProps}>
      <SectionContainer grid className={containerClassName}>
        <h2 className="col-span-full order-1 text-style-headline2">
          Your application
        </h2>

        <div className="col-span-full laptop:col-span-6 order-3 laptop:order-2">
          <Markdown content={learningOpp.admissionProcessInformation ?? ""} />
        </div>

        {learningOpp.userAdmissionData && (
          <AdmissionProgress
            className="col-span-full laptop:col-span-6 order-2 laptop:order-3"
            learningOpp={learningOpp}
            userAdmissionData={learningOpp.userAdmissionData}
            userAdmissionFiles={userAdmissionFiles}
          />
        )}
      </SectionContainer>
    </Section>
  );
};
